import React from 'react'
import Menu from '../component/Menu';
import { Helmet } from 'react-helmet';
import Getintouch2 from '../component/Getintouch2'
import ServicesHeader from '../component/ServicesHeader';
import Whoweserve from '../component/Whoweserve';
import ServiceDesc from '../component/ServiceDesc';
import AIInServices from '../component/AIInService';
import ServiceSection from '../component/ServiceSection';


import heroimage from '../images/Ai-Data-bg.webp';

import service1heroImage from '../images/InfraEngg.webp';
import ser1cs from '../images/case-study-client51.webp';
import service2heroImage from '../images/SoftEngg.webp';
import ser2cs from '../images/case-study-client23.webp';
import service3heroImage from '../images/AnalyticsIntelligence.webp';
import ser3cs from '../images/case-study-client22.webp';
import service4heroImage from '../images/AIML.webp';
import ser4cs from '../images/case-study-client50.webp';
import FaqServices from '../component/FaqServices';


import ServiceCS from '../component/ServiceCS';

import aics1 from '../images/case-study-client51.webp';
import aics2 from '../images/case-study-client22.webp';
import aics3 from '../images/case-study-client14.webp';
import FooterNew from '../component/FooterNew';



const herocontent = {
  "l1": "Insight driven",
  "l2": "AI & Data Solutions",
  "l3": "Equipping businesses to make data-driven decisions, built on systems that work",
  "img": heroimage
};


const serviceDes = {
    description:
      "Data, AI, and software that work together - built for institutional operators who need to act with confidence, not guesswork",

    stats: [
      {
        title: "50%",
        text: "AI-Augmented Data Workflow",
      },
      {
        title: "50-70%",
        text: "Efficiency Gain",
      },
      {
        title: "4-6",
        text: "Weeks from Kick Off to First Value",
      },
      
    ],

    cta: {
      text: "VIEW OUR CASE STUDIES",
      href: "/case-studies",
    },
  };

const aiDataSolutions = {
    eyebrow: "ARTIFICIAL INTELLIGENCE",

    title: "AI in Data Analytics",

    description:
      "AI has moved analytics from describing the past to predicting - and shaping - what comes next. For organizations sitting on growing volumes of data, AI-powered analytics is becoming table stakes for staying competitive. We help you move up the maturity curve: from static reports, to intelligent dashboards, to AI systems that surface answers before you ask.",

    cards: [
      {
        icon: "fpa",
        title: "From dashboards to decisions",
        description:
          "We embed AI and machine learning into your BI stack - enabling forecasting, anomaly detection, and scenario modeling - so your dashboards don't just report performance, they recommend action.",
      },
      {
        icon: "reporting",
        title: "Automated data operations",
        description:
          "We use AI to streamline the unglamorous work that consumes analytics teams: data cleaning, reconciliation, pipeline monitoring, and recurring MIS - freeing your data talent to focus on insight, not plumbing.",
      },
      {
        icon: "risk",
        title: "Self-serve intelligence",
        description:
          "We help you deploy natural-language and agentic AI interfaces on top of your data - so business users across your organisation can query, explore, and act on data without waiting on an analyst.",
      },
    ],

    bottom: [
      {
        title: "REAL OUTCOMES",
        description:
          "We've helped clients turn raw data into working AI systems - from predictive models that improved forecast accuracy to automated reporting suites that cut monthly close-out effort significantly. The result: analytics that pays for itself in decisions.",
        linkText: "Read the case study",
        href: "/case-studies",
      },
      {
        title: "HOW WE HELP",
        description:
          "From building your BI foundation to developing your AI roadmap and executing bottom-up, our data professionals work as an extension of your team - delivering enterprise-grade analytics with the agility and economics of an offshore partner.",
        linkText: "Talk to our team",
        href: "/contact",
      },
    ],
  };

const aiDataSolutionsicons = {
  fpa: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.0007 11.9997V5.33301H26.6673V11.9997H18.0007ZM5.33398 15.9997V5.33301H14.0007V15.9997H5.33398ZM18.0007 26.6663V15.9997H26.6673V26.6663H18.0007ZM5.33398 26.6663V19.9997H14.0007V26.6663H5.33398ZM6.66732 14.6663H12.6673V6.66634H6.66732V14.6663ZM19.334 25.333H25.334V17.333H19.334V25.333ZM19.334 10.6663H25.334V6.66634H19.334V10.6663ZM6.66732 25.333H12.6673V21.333H6.66732V25.333Z" fill="white"/>
</svg>
  ),

  reporting: (
    <svg width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.49293 6.90818C5.78523 7.07305 6.11599 7.15924 6.45232 7.15818C6.78865 7.15712 7.11884 7.06886 7.41008 6.90217C7.70133 6.73547 7.94347 6.49615 8.11246 6.20798C8.28145 5.91981 8.37139 5.59283 8.37335 5.25954H10.3108C10.3127 5.59302 10.4026 5.9202 10.5716 6.20855C10.7407 6.49689 10.983 6.73635 11.2744 6.90308C11.5659 7.06981 11.8963 7.15802 12.2328 7.15891C12.5693 7.15981 12.9002 7.07336 13.1926 6.90818L14.1613 8.56962C14.6999 8.27138 15.3445 8.07426 16.0006 7.95778C15.961 7.84258 15.9094 7.72994 15.8456 7.61986L14.8653 5.93922C14.6117 5.5031 14.1945 5.18396 13.7046 5.05137C13.2146 4.91877 12.6917 4.98348 12.2496 5.23138C12.2452 4.72801 12.0401 4.24678 11.6791 3.89263C11.3181 3.53848 10.8305 3.34013 10.3225 3.34082H8.36431C7.30514 3.34082 6.44618 4.18562 6.43714 5.23266C5.99501 4.98436 5.47171 4.91943 4.98145 5.05204C4.49118 5.18465 4.07374 5.50403 3.82022 5.9405L2.84114 7.61986C2.31156 8.52866 2.62156 9.68834 3.53089 10.2195C3.09287 10.4748 2.77452 10.8915 2.6453 11.3785C2.51608 11.8655 2.58648 12.3834 2.84114 12.8192L3.82022 14.4999C4.34981 15.4087 5.51747 15.7223 6.43714 15.2077C6.44489 15.9987 6.93831 16.6759 7.63581 16.9587C7.63193 16.2279 7.81664 15.4867 8.21318 14.8083L8.30101 14.6573C8.21944 14.3799 8.07551 14.1245 7.88004 13.9102C7.68457 13.6958 7.44264 13.5282 7.17241 13.4198C6.90218 13.3114 6.61068 13.2651 6.3198 13.2843C6.02892 13.3036 5.74622 13.3879 5.49293 13.5309L4.52418 11.8682C5.79647 11.1309 5.79647 9.30818 4.52418 8.5709L5.49293 6.90818Z" fill="white"/>
<path d="M9.34375 12.1398C9.85761 12.1398 10.3504 11.9375 10.7138 11.5775C11.0771 11.2174 11.2812 10.729 11.2812 10.2198C11.2812 9.71059 11.0771 9.22223 10.7138 8.86216C10.3504 8.50209 9.85761 8.2998 9.34375 8.2998C8.82989 8.2998 8.33708 8.50209 7.97373 8.86216C7.61038 9.22223 7.40625 9.71059 7.40625 10.2198C7.40625 10.729 7.61038 11.2174 7.97373 11.5775C8.33708 11.9375 8.82989 12.1398 9.34375 12.1398Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.0352 19.3412C15.0352 18.3007 15.4523 17.3028 16.1947 16.567C16.9372 15.8313 17.9441 15.418 18.9941 15.418C20.0441 15.418 21.0511 15.8313 21.7935 16.567C22.536 17.3028 22.9531 18.3007 22.9531 19.3412C22.9531 20.3817 22.536 21.3795 21.7935 22.1153C21.0511 22.851 20.0441 23.2644 18.9941 23.2644C17.9441 23.2644 16.9372 22.851 16.1947 22.1153C15.4523 21.3795 15.0352 20.3817 15.0352 19.3412ZM18.9954 17.3392C18.7299 17.3392 18.4671 17.3911 18.2218 17.4917C17.9766 17.5924 17.7537 17.74 17.566 17.926C17.3783 18.112 17.2294 18.3328 17.1278 18.5759C17.0262 18.8189 16.9739 19.0794 16.9739 19.3424C16.9739 19.6055 17.0262 19.866 17.1278 20.109C17.2294 20.3521 17.3783 20.5729 17.566 20.7589C17.7537 20.9449 17.9766 21.0925 18.2218 21.1932C18.4671 21.2938 18.7299 21.3456 18.9954 21.3456C19.5315 21.3456 20.0457 21.1346 20.4248 20.7589C20.8039 20.3833 21.0169 19.8737 21.0169 19.3424C21.0169 18.8112 20.8039 18.3016 20.4248 17.926C20.0457 17.5503 19.5315 17.3392 18.9954 17.3392Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.892 22.9159C9.73632 22.649 9.63525 22.3544 9.59456 22.0487C9.55387 21.7431 9.57435 21.4325 9.65485 21.1348C9.73534 20.837 9.87425 20.5578 10.0637 20.3133C10.2531 20.0688 10.4892 19.8636 10.7587 19.7095C10.8239 19.6721 10.8779 19.6183 10.9155 19.5536C10.9531 19.4889 10.9729 19.4156 10.9729 19.3409C10.9729 19.2663 10.9531 19.1929 10.9155 19.1282C10.8779 19.0635 10.8239 19.0097 10.7587 18.9723C10.2151 18.6609 9.8185 18.1484 9.65621 17.5473C9.49391 16.9462 9.57919 16.3059 9.89329 15.7671L11.3219 13.3147C11.636 12.7763 12.153 12.3835 12.7593 12.2227C13.3655 12.0619 14.0114 12.1462 14.5549 12.4571C14.6202 12.4947 14.6943 12.5146 14.7698 12.5147C14.8454 12.5149 14.9196 12.4953 14.985 12.4578C15.0504 12.4204 15.1047 12.3666 15.1423 12.3017C15.18 12.2368 15.1997 12.1633 15.1995 12.0884C15.1995 10.7931 16.2586 9.74219 17.5658 9.74219H20.4242C21.7327 9.74219 22.7919 10.7931 22.7919 12.0884C22.7919 12.4161 23.1497 12.6209 23.4351 12.4571C23.7041 12.3026 24.0012 12.2023 24.3094 12.1618C24.6176 12.1214 24.9309 12.1415 25.2312 12.2212C25.5315 12.3009 25.813 12.4385 26.0596 12.6261C26.3062 12.8137 26.513 13.0477 26.6682 13.3147L28.098 15.7697C28.2537 16.0362 28.3547 16.3306 28.3955 16.6358C28.4362 16.9411 28.4158 17.2514 28.3354 17.5488C28.2551 17.8463 28.1163 18.1251 27.927 18.3693C27.7378 18.6136 27.5018 18.8185 27.2326 18.9723C27.1671 19.0095 27.1127 19.0632 27.0749 19.1279C27.0371 19.1926 27.0171 19.2661 27.0171 19.3409C27.0171 19.4157 27.0371 19.4892 27.0749 19.5539C27.1127 19.6186 27.1671 19.6723 27.2326 19.7095C27.7759 20.0209 28.1722 20.5332 28.3345 21.134C28.4968 21.7347 28.4117 22.3747 28.098 22.9134L26.6707 25.3659C26.5153 25.6327 26.3083 25.8666 26.0616 26.0542C25.815 26.2418 25.5334 26.3794 25.2331 26.4591C24.9328 26.5389 24.6195 26.5592 24.3112 26.519C24.003 26.4788 23.7057 26.3788 23.4364 26.2247C23.371 26.1872 23.2969 26.1674 23.2213 26.1673C23.1457 26.1672 23.0715 26.1868 23.006 26.2242C22.9406 26.2615 22.8862 26.3153 22.8483 26.3801C22.8105 26.445 22.7906 26.5185 22.7906 26.5934C22.7906 27.89 21.7314 28.9396 20.4242 28.9396H17.5671C16.9394 28.9396 16.3374 28.6926 15.8934 28.2529C15.4494 27.8132 15.1998 27.2167 15.1995 26.5947C15.1994 26.5198 15.1795 26.4462 15.1417 26.3814C15.1039 26.3166 15.0495 26.2628 14.984 26.2254C14.9185 26.1881 14.8443 26.1684 14.7687 26.1686C14.6932 26.1687 14.619 26.1885 14.5536 26.226C14.0099 26.5368 13.3639 26.6209 12.7577 26.4598C12.1514 26.2987 11.6345 25.9057 11.3206 25.3671L9.892 22.9159ZM11.7275 21.3723C11.6783 21.4002 11.6353 21.4376 11.6008 21.4821C11.5662 21.5266 11.5409 21.5774 11.5263 21.6317C11.5116 21.6859 11.5079 21.7425 11.5154 21.7981C11.5229 21.8538 11.5414 21.9074 11.5699 21.9559L12.9985 24.4071C13.1173 24.6119 13.3795 24.6811 13.5862 24.5633C15.1633 23.6609 17.137 24.7886 17.137 26.5947C17.137 26.8289 17.3294 27.0196 17.5671 27.0196H20.4242C20.5383 27.0196 20.6477 26.9747 20.7284 26.8948C20.8091 26.8148 20.8544 26.7064 20.8544 26.5934C20.8544 24.7886 22.8267 23.6596 24.4052 24.562C24.6118 24.6798 24.874 24.6094 24.9929 24.4059L26.4215 21.9534C26.4781 21.8556 26.4934 21.7395 26.4638 21.6306C26.4343 21.5216 26.3624 21.4288 26.2639 21.3723C24.6867 20.4699 24.6855 18.2132 26.2639 17.3095C26.3128 17.2818 26.3556 17.2448 26.39 17.2006C26.4243 17.1564 26.4495 17.1058 26.464 17.0519C26.4785 16.998 26.4822 16.9418 26.4746 16.8865C26.4671 16.8312 26.4486 16.7779 26.4202 16.7297L24.9903 14.2759C24.9624 14.2272 24.9251 14.1845 24.8804 14.1502C24.8357 14.1159 24.7846 14.0908 24.7301 14.0763C24.6755 14.0617 24.6186 14.0581 24.5626 14.0656C24.5066 14.073 24.4526 14.0915 24.4039 14.1198C22.8267 15.0235 20.8544 13.8932 20.8544 12.0884C20.8544 11.9754 20.8091 11.867 20.7284 11.787C20.6477 11.7071 20.5383 11.6622 20.4242 11.6622H17.5671C17.5106 11.6618 17.4545 11.6726 17.4023 11.694C17.35 11.7153 17.3025 11.7467 17.2626 11.7863C17.2227 11.826 17.1912 11.8731 17.1698 11.925C17.1485 11.9769 17.1377 12.0324 17.1382 12.0884C17.1382 13.8932 15.1659 15.0222 13.5875 14.1185C13.4887 14.0624 13.3716 14.0473 13.2617 14.0765C13.1518 14.1058 13.058 14.177 13.001 14.2747L11.5725 16.7271C11.5442 16.7756 11.5259 16.8292 11.5185 16.8847C11.5111 16.9402 11.5148 16.9966 11.5295 17.0507C11.5441 17.1048 11.5694 17.1555 11.6038 17.1999C11.6382 17.2443 11.6811 17.2816 11.73 17.3095C13.3085 18.2119 13.3059 20.4711 11.73 21.3723" fill="white"/>
</svg>
  ),

  risk: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.3327 29.3337V28.667C21.3327 27.1937 22.5753 26.0003 23.8953 25.347C25.1793 24.7137 26.258 23.667 26.3953 22.4403L26.666 20.0003L29.3327 18.667L25.9993 13.667C26.0001 10.9222 24.9746 8.27636 23.1244 6.24898C21.2741 4.22159 18.7327 2.95918 15.9993 2.70966M8.66602 22.6617V29.3337M11.9993 24.2523C10.7913 23.911 9.66602 23.3683 8.66602 22.6617C7.28347 21.6858 6.14313 20.4059 5.33268 18.9203M7.33268 13.3337V16.0003M11.3327 13.3337V16.0003M7.33268 2.66699V5.33366M11.3327 2.66699V5.33366M5.33268 7.33366H2.66602M5.33268 11.3337H2.66602M15.9993 7.33366H13.3327M15.9993 11.3337H13.3327M10.666 5.33366H7.99935C6.74202 5.33366 6.11402 5.33366 5.72335 5.72433C5.33268 6.11499 5.33268 6.74299 5.33268 8.00033V10.667C5.33268 11.9243 5.33268 12.5523 5.72335 12.943C6.11402 13.3337 6.74202 13.3337 7.99935 13.3337H10.666C11.9233 13.3337 12.5513 13.3337 12.942 12.943C13.3327 12.5523 13.3327 11.9243 13.3327 10.667V8.00033C13.3327 6.74299 13.3327 6.11499 12.942 5.72433C12.5513 5.33366 11.9233 5.33366 10.666 5.33366Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  ),
};

const InfraEngg = {
  title: ["Data Infrastructure & Engineering"],

  accentColor: "#f21b70",
  bg:'#ffffff',
  subtitle:
    "Fragmented systems, turned into a single source of truth.",

  relevantFor: [
    "Corporates",
    "Private Equity / Venture Capital",
    "Family Offices",
    "Real Estate",
  ],

  heroImage:
    service1heroImage,

  services1: [
    {
      title: "Data Architecture",
      description:
        "Design a data ecosystem built to scale - the right models, databases, and infrastructure from day one.",
    },
    
    {
      title: "Data Warehousing & Cloud Migration",
      description:
        "Centralise data into one warehouse and move it to the cloud with near-zero downtime.",
    },
    {
      title: "Data Transformation",
      description:
        "Clean, standardise, and enrich raw data so it's ready to power analytics and AI - not just storage.",
    },
   {
      title: "Data Governance & Integrity",
      description:
        "Put guardrails around accuracy, privacy, and access, so compliance is built in, not bolted on.",
    }
   ],

  services2: [
    // {
    //   title: "Data Governance & Integrity",
    //   description:
    //     "Put guardrails around accuracy, privacy, and access, so compliance is built in, not bolted on.",
    // },
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser1cs,
    title:"Reporting Automation",
    description:"Delivered a structured, scalable platform integrating user inputs, backend processing and BI reporting within a controlled workflow. The solution standardised feasibility assessments, improved portfolio-level visibility and reduced routine model update effort by ~50% (from 6-7 hours to 3-3.5 hours), while enabling teams to evaluate 45+ projects simultaneously and generate portfolio-level insights in seconds.",
    buttonLabel: "→",
    href: "/knowledge/reporting-automation",
  },
};

const SoftEngg = {
  title: ["Software Engineering"],

  accentColor: "#f21b70",
  bg:'#EBEBEB',
  subtitle:
    "Software built to fit how you work, not the other way around.",

  relevantFor: [
    "Corporates & Growth-Stage Businesses",
    "Asset Managers",
    "Family Offices",
  ],

  heroImage:
    service2heroImage,

  services1: [
    {
      title: "Enterprise Application Development",
      description:
        "Build the platform or tool your workflow actually needs, not a stretched-fit off-the-shelf product.",
    },
    
    {
      title: "Systems & Data Integration",
      description:
        "Connect the systems and data you already run into one working pipeline, instead of stitching it together manually.",
    },
    {
      title: "Product & MVP Engineering",
      description:
        "Go from idea to a working product fast enough to test it with real users, not just a slide deck.",
    },
    {
      title: "Platform Engineering & DevOps",
      description:
        "Ship and run software reliably - automated deployment, monitoring, and infrastructure that doesn't fall over.",
    },
  ],

  services2: [
    
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser2cs,
    title:"Case Study Coming Soon",
    description:"",
    buttonLabel: "→",
    href: "#",
  },
};

const AnalyticsIntelligence = {
  title: ["Analytics & Intelligence"],

  accentColor: "#f21b70",
  bg:'#ffffff',
  subtitle:
    "Turn raw data into actionable insights for smarter decisions.",

  relevantFor: [
    "Investment Banks & Advisors",
    "Sovereign Wealth & Endowment Funds",
    "Corporates",
    "Private Equity / Venture Capital",
  ],

  heroImage:
    service3heroImage,

  services1: [
    {
      title: "Data Visualisation",
      description:
        "Turn raw numbers into dashboards your leadership team can read in seconds, not slides.",
    },
    
    {
      title: "Descriptive Analytics",
      description:
        "Know exactly what happened, with historical analysis built for decision-makers, not analysts.",
    },
    {
      title: "Diagnostic Analytics",
      description:
        "Get to the root cause behind the numbers - not just what happened, but why.",
    },
    {
      title: "Data Driven Research",
      description:
        "Back every strategic call with evidence, not instinct - research built to withstand scrutiny.",
    },
  ],

  services2: [
    
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser3cs,
    title:"Customized BI Dashboards",
    description:"The deployment of organization-wide dashboards across HR, finance, project management, infrastructure, and other functions equipped the client with an enhanced medium for extracting actionable insights from their data. The overall solution improved data accuracy and accessibility, enabling function leaders to make informed decisions based on reliable insights.",
    buttonLabel: "→",
    href: "/knowledge/customized-bi-dashboards-for-an-investment-corporate",
  },
};

const AIML = {
  title: ["Artificial Intelligence & Machine Learning"],

  accentColor: "#f21b70",
  bg:'#EBEBEB',
  subtitle:
    "Transform insights into intelligent AI-driven actions.",

  relevantFor: [
    "Corporates & Growth-Stage Businesses",
    "Asset Managers",
    "Family Offices",
  ],

  heroImage:
    service4heroImage,

  services1: [
    {
      title: "Forecasting",
      description:
        "See demand, revenue, and market shifts before they happen, not after.",
    },
    
    {
      title: "Statistical & ML Modeling",
      description:
        "Build models that don't just predict the future - they hold up when you act on them.",
    },
    {
      title: "Generative AI Solutions",
      description:
        "Put LLMs to work on research synthesis, reporting, and pulling answers out of contracts and filings.",
    },
    {
      title: "AI Agents & Process Automation",
      description:
        "Hand off repetitive workflows to AI agents that execute, monitor, and act on insight directly.",
    },
  ],

  services2: [
    
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser4cs,
    title:"Case Study Coming Soon",
    buttonLabel: "→",
    href: "#",
  },
};


 const faqData = {
    title: "What Leaders Want To Know",

    defaultOpen: 0,

    items: [
      {
        question:
          "What issues or challenges are typically articulated by clients at the first point of contact, and in what operational or strategic context do these situations usually arise?",

        answer:
          "Clients usually come to us because the latest information is difficult to access. Their data is often spread across multiple systems, with manual reporting processes sitting on top of it. As a result, teams spend a lot of time on repetitive tasks and still face delays in getting the information they need. More recently, clients have also started asking how AI can help automate these recurring processes and improve efficiency.",
      },

      {
        question:
          "Prior to engaging external support, what approaches have clients already attempted , and what factors most commonly contributed to the breakdown of these efforts?",

        answer:
          "In most cases, clients have already tried to solve the problem internally. In some situations, they may have also worked with an external vendor or tried to implement a SaaS product. These options often fall short because they do not offer the level of customization needed to fit the client’s processes. Even after onboarding a SaaS solution, clients may still need help with integrations, configuration, and building additional layers around the product.",
      },

      {
        question:
          "Following project completion, how do clients typically describe the value delivered when referring to the engagement to peers, and what terminology or framing is commonly used?",

        answer:
          "Based on the limited visibility we have into these conversations, clients usually refer to the work as an automated business intelligence process. They tend to speak about the time saved, the easier access to information, and the ability to get relevant insights more quickly.",
      },

      {
        question:
          "What are the five most frequently produced tangible outputs (e.g., financial models, investment committee memos, market studies), as opposed to broad service categories?",

        answer:
          "The five most frequently produced tangible outputs are Cloud data warehouses, BI dashboards and reporting solutions, System and API integrations, Workflow automation and AI-enabled tools, Software and web application development"
      },


      {
        question:
          "For each key deliverable, which stakeholder group on the client side primarily utilises it, and what specific decision(s) does it inform or enable?",

        answer:
          "Most engagements ultimately result in BI dashboards or reports as the main user-facing output. These are supported by data warehouses, integrations, automation workflows, and AI-enabled solutions. The outputs are used by senior management, finance, investment, operations, technology, and analytics teams to track KPIs, access timely information, reduce manual work, and make faster data-driven decisions.",
      },


      {
        question:
          "Are there deliverables or elements of the engagement that clients did not initially request but ultimately relied upon significantly?",

        answer:
          "In most engagements, the solution architecture is discussed in detail at the start, so there are usually no major deliverables that come as a surprise later. That said, clients often end up relying heavily on supporting elements such as solution design, integration planning, documentation, and workflow improvements because these make the final solution easier to implement and use.",
      },


      {
        question:
          "How do different client segments (e.g., private equity funds, family offices, asset managers) align with specific service lines, and are there observable geographic patterns influencing this alignment?",

        answer:
          "Geography seems to influence demand more clearly than client segment. KSA based clients are mainly focused on BI development and report automation to improve visibility and access to business information. Clients in the US and Europe are more likely to ask for advanced use cases such as workflow automation, AI integrations, and improvements to existing systems and processes.",
      },


      {
        question:
          "Which industry verticals currently demonstrate the strongest depth of experience and a well-developed point of view based on repeated engagements?",

        answer:
          "The strongest depth of experience is currently in BI reporting, systems integration, workflow automation, and early AI integration across solutions. Repeated work in these areas has helped build a clear point of view on how clients can improve access to information, reduce manual effort, and make better use of data in day-to-day decision-making.",
      },
      {
        question:
          "When evaluating alternatives (e.g., larger consulting firms, freelancers, in-house hiring), what factors ultimately drive client selection, and what rationale is typically cited when confirming the engagement?",

        answer:
          "Clients usually choose us because of relevant prior experience, flexibility in the technology stack, and a delivery model that brings together senior oversight, project management, and hands-on execution. This gives clients confidence that the solution will be technically sound, closely managed, and practical to implement.",
      },
      {
        question:
          "What does the first week of an engagement typically involve from the client perspective, how quickly is tangible output delivered, and what characterises the initial working relationship?",

        answer:
          "The first week is usually spent understanding the client’s current processes, data sources, reporting requirements, and expected outcomes. It also involves discovery discussions, access setup, solution architecture, and agreement on priorities. Clients generally start seeing tangible outputs within 2 to 4 weeks, often through prototypes, sample reports, or workflow designs, which helps build confidence early in the engagement.",
      },
      {
        question:
          "Which client types typically inquire about ISO and SOC 2 compliance, and what underlying risks or concerns are driving these questions?",

        answer:
          "ISO and SOC 2 questions are usually raised by larger enterprises, financial services clients, private equity firms, asset managers, or clients with mature technology and procurement teams. The underlying concerns are generally around data security, confidentiality, access controls, vendor risk, regulatory expectations, and the handling of sensitive business or financial information.",
      },
      {
        question:
          "What are the most common concerns raised by prospective clients prior to engagement, and how are these concerns addressed?",

        answer:
          "When concerns come up, they are usually related to data security and are addressed by sharing ISO and SOC 2 audit reports. Clients may also ask about the team’s prior experience on similar projects. Those questions are usually addressed during the solution architecture phase by walking through relevant experience and showing how the proposed approach fits the client’s requirements.",
      },
      {
        question:
          "In cases where clients have previously worked with offshore providers, what issues or shortcomings are most frequently cited, and what differentiates subsequent engagements and outcomes?",

        answer:
          "This situation comes up relatively rarely. When clients have worked with offshore providers before, the concern is usually not the offshore model itself, but whether the provider has the right technical experience, can work with the required tools and integrations, and can deliver a robust, scalable solution.",
      },
      {
        question:
          "Provide an example of an engagement conducted under significant constraints (e.g., tight timelines, deal risk, board deadlines); what actions were taken, and how was the outcome perceived by the client?",

        answer:
          "One example was a greenfield project to build a financial modelling software platform that included a web application, a Microsoft add-in, and Power BI dashboards. The timeline became challenging because the project required significant R&D around product architecture, technical feasibility, and integration across multiple components. To manage this, the team added resources, ran parallel workstreams, and stayed closely aligned on priorities so the delivery timeline was not significantly affected.",
      },
      {
        question:
          "Are there examples of clients who initially engaged for one service line and subsequently expanded into additional services, and what factors enabled or triggered this progression?",

        answer:
          "Many clients who first engage us for other consulting work expand the relationship through business intelligence related projects. Over time, depending on their requirements, these engagements can move into more advanced areas such as AI integration, workflow automation, and software development.",
      },
      {
        question:
          "What keywords or phrases should be prioritised across the website to improve discoverability among target clients? Eg: AI Consulting / Management Organization",

        answer:
          "Priority keywords and phrases should include: Digital transformation, AI transformation, AI consulting, Business intelligence consulting, BI dashboard development, Data automation, Workflow automation, Software development, Web application development, Systems and API integration, Cloud migration, Cloud data warehouse, Data engineering, Power BI dashboards, Reporting automation",
      },
    ],
  };

const  caseStudies =  {
  "sectionTitle": "Case Studies",
  "title" : "What our clients say",
  "showTitle" : true,
  "items": [
    {
      "id": 1,
      "image": aics1,
      "title": "Reporting Automation",
      "description": "The client is a quasi-government real estate developer mandated to deliver large-scale projects and increase home ownership across middle-east, with a portfolio of 50+ projects across multiple regions",
      "link": "/knowledge/reporting-automation"
    },
    {
      "id": 2,
      "image": aics2,
      "title": "Customized BI Dashboards",
      "description": "The client is an investment corporation managing an AUM of $750 million, specializing in diverse asset classes including public and private equity, fixed income products, etc.",
      "link": "/knowledge/customized-bi-dashboards-for-an-investment-corporate"
    },
    {
      "id": 3,
      "image": aics3,
      "title": "HR Reporting Dashboard",
      "description": "The client is a closed joint stock company in the hospitality sector owned by a Sovereign Wealth Fund. They specialize in creating unique travel experiences through eco-tourism, agri-tourism, and adventure tourism.",
      "link": "/knowledge/human-resource-reporting-dashboard-for-a-company-in-the-hospitality-industry"
    }
  ]
}

const AIDataService = ({setBlank}) => {
  return (
     <>
        <Helmet>
            <title>AI & Data Solutions</title>
             <meta property="og:title" content="AI & Data Solutions" />
             <meta name='og:description' content='AI & Data Solutions' />
             <meta name='keywords' content='' />
        </Helmet>
        <Menu setBlank={setBlank} />
        <ServicesHeader herocontent={herocontent} />
        <ServiceDesc serviceDes={serviceDes} />
        <AIInServices data={aiDataSolutions} icons={aiDataSolutionsicons} />
        <ServiceSection data={InfraEngg} />
        <ServiceSection data={SoftEngg} />
        <ServiceSection data={AnalyticsIntelligence} />
        <ServiceSection data={AIML} />
        <Whoweserve />
        <Getintouch2 setBlank={setBlank} />
        <ServiceCS caseStudies={caseStudies} />
        <FaqServices data={faqData} />
        <FooterNew setBlank={setBlank} />
     </>
  )
}

export default AIDataService



